<mat-nav-list>
    <a mat-list-item routerLinkActive="list-item-active" routerLink="/pacslist" (click)="activeClick1()" class="{{flag1 ? 'aActive' : ''}}">
        <img src="{{flag1 ? 'assets/yxzx_menu_white_home.png' : 'assets/yxzx_menu_blue_home.png'}}" alt="" class="iconImg">影像管理</a>        
    <a mat-list-item routerLinkActive="list-item-active" routerLink="/pacs/add" (click)="activeClick2()" class="{{flag2 ? 'aActive' : ''}}">
        <img src="{{flag2 ? 'assets/yxzx_menu_white_tjyxwj.png' : 'assets/yxzx_menu_blue_tjyxwj.png'}}" alt="" class="iconImg">添加影像</a> 
</mat-nav-list>


<!-- <mat-nav-list>
    <a mat-list-item routerLinkActive="list-item-active" *ngFor="let item of menuList" routerLink="/{{item.mapping}}" (click)="gotoPage(item)" class="{{item.class}}">
        <img src="assets/{{item.imgPath}}" alt="" class="iconImg">
        {{item.name}}</a>
</mat-nav-list> -->